import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50372c5f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "carousel-indicators" }
const _hoisted_3 = ["data-bs-target", "data-bs-slide-to", "aria-label"]
const _hoisted_4 = { class: "carousel-inner" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["data-bs-target"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "carousel-control-prev-icon",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Previous", -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = ["data-bs-target"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "carousel-control-next-icon",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Next", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id,
    class: "carousel",
    "data-bs-ride": "carousel"
  }, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
        return (_openBlock(), _createElementBlock("button", {
          key: index,
          type: "button",
          "data-bs-target": `#${_ctx.id}`,
          "data-bs-slide-to": index,
          class: _normalizeClass({ active: index === 0 }),
          "aria-label": image
        }, null, 10, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["carousel-item", { active: index === 0 }]),
          key: image
        }, [
          _createElementVNode("img", {
            src: image,
            class: "d-block w-100 kometa-image-rounded",
            alt: index
          }, null, 8, _hoisted_5)
        ], 2))
      }), 128))
    ]),
    _createElementVNode("button", {
      class: "carousel-control-prev",
      type: "button",
      "data-bs-target": `#${_ctx.id}`,
      "data-bs-slide": "prev"
    }, _hoisted_9, 8, _hoisted_6),
    _createElementVNode("button", {
      class: "carousel-control-next",
      type: "button",
      "data-bs-target": `#${_ctx.id}`,
      "data-bs-slide": "next"
    }, _hoisted_13, 8, _hoisted_10)
  ], 8, _hoisted_1))
}